import { FormControl, RadioGroup } from '@mui/material';
import React, { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioButtonStyled } from '../../../../../../theme/style';
import { FormLabelStyled, FormControlLabelStyled } from '../../styled';

interface QuantileRadioButtonsProps {
    hasQuantilesView: boolean,
    setHasQuantileView: Dispatch<SetStateAction<boolean>>
}

const QuantileRadioButtons: FC<QuantileRadioButtonsProps> = ({ hasQuantilesView, setHasQuantileView }) => {
    const { t } = useTranslation('dashboard');
    const handleDisplayQuantile = (isInteger: boolean) => {
        setHasQuantileView(isInteger);
    };

    return (
        <FormControl>
            <FormLabelStyled>
                {t('addIndicatorModal.commonAddIndicator.displayQuantiles')}
            </FormLabelStyled>

            <RadioGroup
                aria-labelledby="radio-buttons-group-label"
                name="radio-buttons-group"
                sx={{ display: 'flex', flexDirection: 'row', gap: '24px' }}
                value={hasQuantilesView ? 'withQuantiles' : 'withoutQuantiles'}
            >
                <FormControlLabelStyled
                    key="withQuantiles"
                    control={<RadioButtonStyled />}
                    ischecked={!hasQuantilesView ? 1 : 0}
                    label={t('addIndicatorModal.commonAddIndicator.yes')}
                    onClick={() => handleDisplayQuantile(true)}
                    value="withQuantiles"
                />
                <FormControlLabelStyled
                    key="withoutQuantiles"
                    control={<RadioButtonStyled />}
                    ischecked={hasQuantilesView ? 1 : 0}
                    label={t('addIndicatorModal.commonAddIndicator.no')}
                    onClick={() => handleDisplayQuantile(false)}
                    value="withoutQuantiles"
                />
            </RadioGroup>
        </FormControl>
    );
};

export default QuantileRadioButtons;
